module.exports = __webpack_public_path__ + "static/media/waiter.6d902638.png";